import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const LandingNav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#080C1E]/95 backdrop-blur-md border-b border-white/[0.07]' : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="cursor-pointer">
          <img
            src="https://storage.readdy-site.link/project_files/88b042fa-1b1e-4828-a084-65a05e6769ac/242fee5f-76d2-4bf5-b968-77fd062724cd_IMG_20260126_015045_031.webp?v=f427f7850abf122c2fe0f72017d39364"
            alt="AD.NOVA.PRO"
            className="h-9 w-auto object-contain"
          />
        </Link>
        <div className="flex items-center gap-3">
          <Link
            to="/auth/signin"
            className="text-sm font-medium text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap px-3 py-2"
          >
            Se connecter
          </Link>
          <Link
            to="/auth/signup"
            className="text-sm font-bold bg-[#C9A227] text-[#080C1E] px-4 py-2 rounded-lg hover:bg-[#D4B84A] transition-colors cursor-pointer whitespace-nowrap"
          >
            Créer mon compte
          </Link>
        </div>
      </div>
    </header>
  );
};

export default LandingNav;
